import { createActionsStructure } from 'services/reduxHelpers'

/* ------------- Action Creators ------------- */

export const { settingsTypes, settingsActions } = createActionsStructure('settings', [
  { name: 'CHANGE_SWIPE_FIRST_LOOK', async: false }
])
